<template>
  <div class="rootDiv">
    <Tabs>
      <Tab title="各省渔具店" label="">
        <Collapse v-model="activeNames" accordion>
          <CollapseItem v-for="item in ProvinceShopList" :name="item.sXMC" style="text-align: left"
                        :key="item.sXMC" :is-link="true">
            <template #title>
              <div><span style="color: black">{{ item.sXMC }}</span></div>
            </template>
            <template #value>
              <div><span style="color: black">数量：{{ item.total }}</span></div>
            </template>
            <Cell :title="city.cSMC" v-for="city in item.cityList" :key="city.cSMC" class="cellstyle"
                  v-on:click.native="GoProvince(city.cSID,2)"
                  :is-link="true">
              <img slot="icon" src="../../../../assets/images/32/administration_icon.png" width="24" height="24" alt="">
              <div v-if="city.sL>0">
                <img style="margin-left: 10px" src="../../../../assets/images/16/fishing_station.png" width="16"
                     height="16"
                     alt="">
                <span>{{ city.sL }}</span>
              </div>
            </Cell>
          </CollapseItem>
        </Collapse>
      </Tab>
      <Tab title="各省钓点" label="">
        <Collapse v-model="activeNames1" accordion>
          <CollapseItem v-for="item in ProvinceList" :name="item.sXMC" style="text-align: left"
                        :key="item.sXMC" :is-link="true">
            <template #title>
              <div><span style="color: black">{{ item.sXMC }}</span></div>
            </template>
            <template #value>
              <div><span style="color: black">数量：{{ item.total }}</span></div>
            </template>
            <Cell :title="city.cSMC" v-for="city in item.cityList" :key="city.cSMC" class="cellstyle"
                  v-on:click.native="GoProvince(city.cSID,1)"
                  :is-link="true">
              <img slot="icon" src="../../../../assets/images/32/administration_icon.png" width="24" height="24" alt="">
              <div v-if="city.sL>0">
                <img style="margin-left: 10px" src="../../../../assets/images/16/fishing_station.png" width="16"
                     height="16"
                     alt="">
                <span>{{ city.sL }}</span>
              </div>
            </Cell>
          </CollapseItem>
        </Collapse>
      </Tab>
      <Tab title="钓点地图" label="">
        <MapControl :center="getCenter()" :scale="11" :markers="getMarkers()"></MapControl>
      </Tab>
    </Tabs>
  </div>
</template>

<script>
import {Cell, Indicator} from "mint-ui";
import MapControl from "@/controls/MapControl";
import {Tab, Tabs, Collapse, CollapseItem} from "vant";
import 'vant/lib/collapse-item/index.css'

export default {
  name: "FinshingMain",
  components: {
    MapControl,
    Cell, Tab, Tabs, Collapse, CollapseItem
  },
  data() {
    return {
      activeNames: ['1'],
      activeNames1: ['1'],
      FishingList: [],
      ProvinceList: [],
      ProvinceShopList: [],
      token: localStorage.getItem('token'),
      getFishingListUrl: '/api/fishing/getFishingList',
      getFishingGroupByProvinceUrl: '/api/fishing/getFishingGroupByProvince',
    }
  },
  mounted() {
    window.test = this.test
    this.getFishingGroupByProvince()
    this.getShopGroupByProvince()
    this.getFishingList()
  },
  methods: {
    GoProvince(cSID, type) {
      this.$router.push({path: 'm_fishing_list', query: {sID: cSID, tYPE: type}})
    },
    getShopGroupByProvince() {
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      });
      let that = this
      that.$ajax({
        method: 'get',
        params: {TYPE: 2},
        url: that.getFishingGroupByProvinceUrl,
        headers: {token: that.token, needToken: 'false'}
      }).then((response) => {
        Indicator.close()
        if (!response.data.result)
          that.$messagebox.alert(response.data.message)
        else {
          if (response.data['responseData'].length > 0) {
            that.ProvinceShopList = response.data['responseData']
          }
        }
      }).catch(response => {
        Indicator.close()
        this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
    getFishingGroupByProvince() {
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      });
      let that = this
      that.$ajax({
        method: 'get',
        url: that.getFishingGroupByProvinceUrl,
        params: {TYPE: 1},
        headers: {token: that.token, needToken: 'false'}
      }).then((response) => {
        Indicator.close()
        if (!response.data.result)
          that.$messagebox.alert(response.data.message)
        else {
          if (response.data['responseData'].length > 0) {
            that.ProvinceList = response.data['responseData']
          }
        }
      }).catch(response => {
        Indicator.close()
        this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
    test(item) {
      this.$router.push({name: 'm_hotel_details', params: {id: item}})
    },
    getCenter() {
      if (this.FishingList.length === 0)
        return {lng: 0, lat: 0}
      else
        return {lng: this.FishingList[0].lng, lat: this.FishingList[0].lat}
    },
    getMarkers() {
      let that = this
      let markers = []
      that.FishingList.forEach(item => {
        let P = item.uid
        let image_div = '<div><img src="' + item.pic + '" width="300" alt=""></div>'
        let text_div = '<a href="javascript:test(\'' + P + '\')" style="color: #2986de;font-size: 1.2rem">' + item.name + '</a>'
        let content = '<div>' + image_div + text_div + '</div>'

        let m = {content: content, point: {lng: item.lng, lat: item.lat}}
        markers.push(m)
      })
      return markers
    },
    getFishingList() {
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      });
      let that = this
      that.$ajax({
        method: 'get',
        url: that.getFishingListUrl,
        headers: {token: that.token, needToken: 'false'}
      }).then((response) => {
        Indicator.close()
        if (!response.data.result)
          that.$messagebox.alert(response.data.message)
        else {
          if (response.data['responseData'].length > 0) {
            that.FishingList = response.data['responseData']
          }
        }
      }).catch(response => {
        Indicator.close()
        this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
  },
}
</script>

<style lang="less" scoped>
.cellstyle {
  text-align: left;
}

.rootDiv {
  margin-top: -0.5rem;
}

.title-div {
  background-color: #8450C5;
  padding-top: 5px;
  padding-bottom: 5px;

  span {
    font-size: 1.4rem;
    color: white;
  }
}

/deep/ .van-cell {
  font-size: 20px;
}
</style>
